import * as echarts from "echarts";
import type { Pead } from "epsm-api-types/models";
import { useEffect } from "react";
import type { ChartData, ChartDataState } from "../../../types";
import { generateChartMap } from "../../helpers/generateChartMap/generateChartMap";
import { generateSeriesList } from "../../helpers/generateSeriesList";
import { getChartOptions } from "../../helpers/getChartOptions";

export function useInitChart(
	pead: Pead | null,
	chartId: string,
	lines: ChartDataState,
	timeLine: number[],
	currentPeadAccy: number | string,
	isMainChart: boolean,
	relativeToSpy: boolean,
	priceLine?: ChartData,
	stdDev?: boolean,
) {
	// biome-ignore lint/correctness/useExhaustiveDependencies: correct deps array
	useEffect(() => {
		const chartMap = generateChartMap(lines, timeLine, priceLine);
		const series = generateSeriesList(chartMap, isMainChart);

		if (series.length === 0) return;

		const option = getChartOptions(
			relativeToSpy,
			timeLine,
			series,
			pead,
			isMainChart,
			currentPeadAccy,
			stdDev,
		);

		const chartDom = document.getElementById(`drift-chart-${chartId}`)!;

		if (!chartDom || !chartDom.clientHeight || !chartDom.clientWidth) return;

		const myChart = echarts.init(chartDom, "dark");

		option && myChart.setOption(option);

		const resizeObserver = new ResizeObserver(() => throttledResize(myChart));

		resizeObserver.observe(chartDom);

		return () => {
			resizeObserver.disconnect();
			myChart.dispose();
		};
	}, [pead, lines, priceLine, stdDev, relativeToSpy]);
}

export function throttledResize(myChart: echarts.ECharts) {
	myChart.resize();
}
